import {
   Settings,
   User,
   PanelBottomClose ,
   BookOpenText ,
   CalendarDays,
   UserRoundSearch ,
   // Hop,
   // FilePenLine,
   // BadgeDollarSign,
   Percent,
   DollarSign,
   // Eye,
   // Sheet,
   Printer,
   // Shield,
   Users,
   // ShoppingCart,
   Headphones,
   ChartSpline,
   FileInput,
   File,
   DoorOpen,
   // FileCheck,
   Package ,
   Gift,
   Gem ,Sparkle ,List ,HandHeart ,Signature ,ChartArea ,ChartPie, 
   Mail
} from "lucide-react";

export const menuItemsData = [
   {title: "VENTAS",url: "/",icon: ChartSpline,
      submenu: [
         {title: "Orden",url: "/presupuesto",icon: File ,
            submenu: [
               {title: "Piercing",url: "/presupuesto",icon: Headphones ,},
               { title: "Tattoo",url: "/presupuestot",icon: Sparkle ,},
            ],
         }, 
         {title: "Facturación",url: "/factura",icon: FileInput ,
            submenu: [
               {title: "Piercing",url: "/factura",icon: Headphones ,},
               { title: "Tattoo",url: "/facturat",icon: Sparkle ,},
            ],
         },
         {title: "Gift Card",url: "/giftcardtat",icon: Gift ,
            submenu: [
               {title: "Piercing",url: "/giftcardpier",icon: Headphones ,},
               { title: "Tattoo",url: "/giftcardtat",icon: Sparkle ,},
            ],
         },
      ],
   },
   {title: "EGRESOS",url: "/",icon: DoorOpen ,
      submenu: [
         {title: "Productos",url: "/compra",icon: Gem ,
              submenu: [
               {title: "Piercing",url: "/compra",icon: Headphones,},
               {title: "Tattoo",url: "/compratattoo",icon: Sparkle,},
            ],
         },
         { title: "Insumos",url: "/Insumos",icon: Package ,
            submenu: [
               {title: "Piercing" ,url: "/compraIns",icon: Headphones,},
               {title: "Tattoo"   ,url: "/compraInst",icon: Sparkle ,},
               {title: "Reporte"  ,url: "/comprast",icon: Printer,},
            ],
         },
         {title: "Gastos",url: "/gasto",icon: DollarSign,},         
      ],
   },
   {title: "CATALOGO",url: "/",icon: List ,
      submenu: [
         {title: "Producto",url: "Producto",icon: Gem,
            submenu: [
               {title: "Piercing",url: "/Producto",icon: Headphones,},
               {title: "Tattoo",url: "/Productotattoo",icon: Sparkle,},
            ],
         },
         {title: "Insumos",url: "/Insumos",icon: Package,
            submenu: [
               {title: "Piercing",url: "/insumos",icon: Headphones,},
               {title: "Tattoo",url: "insumost",icon: Sparkle,},
            ],
         },
         {title: "Gastos",url: "/tablagasto",icon: DollarSign,},
         {title: "Servicios",url: "/Servicio",icon: HandHeart ,},
      ],
   },
   {title: "CLIENTES",url: "/",icon: Users,
      submenu: [
         {title: "Cliente",url: "/clientes",icon: UserRoundSearch  ,},
         { title: "Contratos",url: "/",icon: Signature ,
            submenu: [
               {title: "Piercing",url: "/contratop",icon: Headphones,},
               {title: "Tattoo",url: "/contratot",icon: Sparkle,},
            ],
         },
      ],
   }, 
   {title: "AGENDA",url: "Calendario",icon: CalendarDays,},  
   {title: "INFORMES",url: "/",icon: BookOpenText ,
      submenu: [
         {title: "Reportes",url: "/reporte",icon: ChartPie ,},
         {title: "Balances",url: "balance",icon: ChartArea ,},
      ],
   },  
   {
      title: "",url: "/",icon: Settings,
      submenu: [
         {title: "Formas de Pago",url: "/pagos",icon: Percent,},
         {title: "Reposicion",url: "/ganancias",icon: Percent,},
         {title: "Ganancias",url: "/porcentaje",icon: Percent,},
         {title: "Usuarios",url: "/Usuario",icon: User,},
         {title: "Panel",url: "/Panel",icon: PanelBottomClose ,},
         {title: "Correo",url: "/Correo",icon: Mail ,},
      ],
   },
   {title: "Login", url: "Login", icon: User,},
];
